import pako from "pako";

export function compressGzip(data) {
  return pako.gzip(data);
}

export function encodeBase64(data) {
  return btoa(String.fromCharCode(...data));
}
export function base64ToUint8Array(base64String) {
  const binaryString = atob(base64String);
  return new Uint8Array([...binaryString].map((char) => char.charCodeAt(0)));
}

export function decompressGzipFromBase64(compressedData) {
  return pako.ungzip(compressedData, { to: "string" });
}
